<template>
    <Navbar/>
    <main class="py-5">
        <div class="container">
            <div class="d-flex align-items-center flex-wrap px-4 mb-4">
                <router-link to="/dashboard" class="text-third router-link fs-2 me-2" v-if="this.$route.name !== 'DashboardIndex'">
                    <i class="fa-solid fa-chevron-left"></i>
                </router-link>
                <h1 class="fw-bold">
                    {{ $t(`Dashboard.${this.$route.name}.RouteName`) }}
                </h1>
            </div>
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
import Navbar from '../../components/Dashboard/Navbar.vue'
export default {
    name: 'DashboardView',
    components: {
        Navbar
    }
}
</script>